import CustomLink from 'components/link';
import { Case } from 'constants/sdk_api';
import { Tabs } from 'antd';
import cn from 'classnames';
import style from './index.module.scss';

interface IProps {
  list: Case[];
  activeKey: number;
  logoClass?: string;
  className?: string;
}
const TabPane = (props: IProps) => {
  const { list, activeKey, logoClass, className } = props;
  return list.map((item, index: number) => (
    <Tabs.TabPane tab={<img className={cn(style.logo, !!logoClass && logoClass)} src={index === activeKey ? item.logo : item.grayLogo} alt={item.title} />} key={index}>
      <CustomLink isNextLink={false} href={item.link || ''} needTarget={true}>
        <div className={style.mask}>
          <div className={cn(style.introduce, style.tabContent)}>
            <div className={style.image}>
              <img src={item.img} alt={item.title} />
            </div>
            <div className={cn(style.content, !!className && className)}>
              <div className={style.title}>{item.title}</div>
              <div className={style.desc}>
                {item.desc}
                <div></div>
              </div>
            </div>

            <CustomLink isNextLink={false} href={item.link || ''} needTarget={true} className={style.learnMore}>
              了解更多 &gt;
            </CustomLink>
          </div>
        </div>
      </CustomLink>
    </Tabs.TabPane>
  ));
};

export default TabPane;
